import React, { useEffect, useState } from "react";

import { CiLocationOn, CiMail, CiStar } from "react-icons/ci";
import { HiOutlineClipboard, HiOutlineUsers } from "react-icons/hi2";
import { IoBookOutline } from "react-icons/io5";
import { PiPhoneCallLight } from "react-icons/pi";

import { Link } from "react-router-dom";
import "./TeachersProfile.css";
import axios from "axios";

const TeachersProfile = () => {
  const [teacherProfile, setTeacherProfile] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalpage, setTotalPage] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;



  const getAllTeacher=async()=>{
     axios
      .get(`${API_BASE_URL}/admin/search-teacher?currentPage=${currentPage}&searchQuery=${searchInput}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response.data?.teachers);
        setTeacherProfile(response.data?.teachers);
        setTotalPage(response.data?.totalpage)
      })
      .catch((error) => {
        console.log(error);
      });

  }

  useEffect(() => {

     const timeId=setTimeout(()=>{
         getAllTeacher()
     },1000)
      return ()=>clearTimeout(timeId)
  }, [searchInput]);

  useEffect(()=>{
     getAllTeacher()
  },[currentPage])

  return (
    <>
      <div id="teacher-profile-container">
        <div className="profile-header">
          <h4>Teacher's Profile</h4>

          <div className="search-box">
            <input
              type="text"
              value={searchInput}
              placeholder="Search teacher..."
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <span className="search-icon">🔍</span>
          </div>
        </div>
        <div className="teacher-profile-inner-div">
          {teacherProfile &&
            [...teacherProfile]?.reverse()?.map((data, idx) => (
              <div
                className="teacher-profile-card-container border border-2"
                key={idx}
              >
                <div className="teacher-profile-share-teacher-image-box">
                  {data.basicInfo.profilePicture ? (
                    <img
                      src={`${API_BASE_URL}/uploads/${data.basicInfo.profilePicture}`}
                      alt="teacher-img"
                    />
                  ) : (
                    <img
                      src={require("../../../Images/student-profile-img.png")}
                      alt="student-img"
                    />
                  )}
                </div>

                <div className="teacher-profile-teacher-details-box">
                  <p className="student-name-b">
                    <b>{data.basicInfo.fullName}</b>
                    <br />
                    <span style={{ color: "#404040", fontSize: "18px" }}>
                      <CiStar />
                      <CiStar />
                      <CiStar />
                      <CiStar />
                      <CiStar />
                    </span>
                  </p>
                  <Link to={`/teacher-profile-details/${data._id}`}>
                    <p className="share-teacher-profile">
                      <HiOutlineUsers className="icon-margin" />
                      Profile
                    </p>
                  </Link>
                  <p className="student-phone-and-email">
                    <span className="student-contact">
                      <PiPhoneCallLight className="icon-margin" />
                      {data.basicInfo?.contactNumber}
                    </span>
                    <span className="student-email">
                      <CiMail className="icon-margin" />
                      {data.basicInfo?.email}
                    </span>
                  </p>
                  <p className="student-address">
                    <CiLocationOn className="icon-margin" />
                    {data.basicInfo?.address}
                  </p>
                  <p className="teacher-accept-class-checks-boxes">
                    {/* <div>
                      <HiOutlineClipboard />
                    </div> */}
                    <div className="d-flex flex-column gap-2">
                      {data.professionalInfo?.teachingDetails.map(
                        (item, idx) => (
                          <div key={idx} className="w-100">
                            <HiOutlineClipboard className="icon" />
                            {item.className} -{" "}
                            <span>
                              <IoBookOutline className="icon" />
                              {item?.subjects.map((sub, idx) => (
                                <span key={idx}>{sub.subjectName} , </span>
                              ))}
                            </span>{" "}
                          </div>
                        ),
                      )}
                    </div>
                  </p>
                  <p>Approval Status : {data.approvalStatus}</p>
                </div>
              </div>
            ))}
        </div>
        <div className="pagination-conatiner">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>
          <button disabled={true}>{currentPage}</button>
          <button
            disabled={currentPage === totalpage}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default TeachersProfile;
